module.exports = __webpack_public_path__ + "img/social_media-instagram.58adb0e6.svg";